import {createStore} from "redux";

import professionalOrgReducer from "./reducer/professionalOrgReducer";

const professionalOrgStore = createStore(professionalOrgReducer);

export default professionalOrgStore;